<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link
      class="brand-logo"
      @click="$router.push('/')"
    >
      <vuexy-logo />
      <h2 class="brand-text text-primary ml-1">
        Lenon
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Not Authorized 🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          Oops! 😖 You do not have the required permission to access this feature. Contact your school admin for assistance, and then logout and login again.
        </p>
        <lenon-button
          label="Go Back"
          icon="ArrowLeftIcon"
          variant="outline-primary"
          @onClick="goHome()"
        />

        <!--        <b-button-->
        <!--          variant="primary"-->
        <!--          class="mb-2 btn-sm-block"-->
        <!--          @click="$router.go(-1)"-->
        <!--        >-->
        <!--          Go Back-->
        <!--        </b-button>-->

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
        />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import LenonButton from '@/lenon/components/LenonButton'

export default {
  components: {
    LenonButton,
    VuexyLogo,
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    goHome() {
      const cm = localStorage.getItem('unauthorized_module')
      localStorage.removeItem(cm)
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
